import { requireConfigValue } from "../../isomorphic-config";
import Cookies from "js-cookie";
export const getWishlistToken = ()=>Cookies.get(requireConfigValue("wishlistCookieName"));
export const setWishlistToken = (wishlistToken)=>{
    const cookieOptions = {
        expires: requireConfigValue("wishlistCookieExpire")
    };
    Cookies.set(requireConfigValue("wishlistCookieName"), wishlistToken, cookieOptions);
};
export const removeWishlistToken = ()=>{
    Cookies.remove(requireConfigValue("wishlistCookieName"));
};
